import React from "react";
import { Perspective } from "../../../../App";
import { PerspectivesHelper } from "../../../../helpers/perspectives.helper";
import StandardButton, { StandardButtonTheme } from "../../../common/button/StandardButton";
import './PerspectivePanelItem.scoped.scss';

interface ComponentProps {
    didClickOnLearnMore: (perspective: Perspective) => void;
    presentModalContent: (content: JSX.Element) => void;
    didClickOnPerspective: (perspective: Perspective) => void;
    perspective: Perspective;
    isActive: boolean;
}

class PerspectivePanelItem extends React.Component<ComponentProps, any> {
    shouldComponentUpdate(nextProps: ComponentProps, nextState: any) {
        if (this.props.perspective !== nextProps.perspective) {
            return true;
        }
        if (this.props.isActive !== nextProps.isActive) {
            return true;
        }
        return false;
    }

    moveBackToMainSection() {
        this.props.didClickOnPerspective(Perspective.General);
    }

    didClickOnLearnMore = () => {
        if (this.props.perspective !== Perspective.General) {
            const contentPerspective = PerspectivesHelper.perspectiveContentForPerspective(this.props.perspective);
            window.open("https://www.unicef-irc.org/publications/pdf/What-Makes-Me_Core-Capacities-for-Living-and-Learning.pdf#page=20", '_blank')?.focus();
        } else {
            window.open("https://www.unicef-irc.org/publications/pdf/What-Makes-Me_Core-Capacities-for-Living-and-Learning.pdf#page=20", '_blank')?.focus();
        }
    }

    presentModal = () => {
        const contentPerspective = PerspectivesHelper.perspectiveContentForPerspective(this.props.perspective);
        let modalContent: JSX.Element =
            <div className="modal-content">
                <div className="panel-title categoryPanel">{contentPerspective.name}</div>
                <div className="panel-description fullHeight mainDescription categoryPanel">
                    <span dangerouslySetInnerHTML={{ __html: contentPerspective.description }}></span>
                </div>
            </div>
        this.props.presentModalContent(modalContent);
    }

    render() {
        let content: JSX.Element;
        if (this.props.perspective === Perspective.General) {
            content = (
                <div className={['panel-innerWrp', this.props.isActive ? 'active' : ''].join(' ')} key={Perspective.General}>
                    <div className="panel-title">What are Perspectives?</div>
                    <div className="panel-description mainDescription">
                        <img className="mobile-whiteFader" src="/assets/tabletPanelWhiteFaderVerticalBottomToTop.png" alt="White gradient overlay to hide text. Purely visual." />
                        Each core capacity can be understood through physical, emotional, mental and spiritual perspectives. These four perspectives are represented by three aspects (mental, emotional, and physical) with the spiritual dimension experienced through “a sense of connection to all things, including the natural and manmade environments”. The spiritual dimension is considered to be pervasive and is therefore indivisible – it both embraces and imbues the three-folded nature of life (as expressed through the mental, emotional, and physical aspects).<br /><br />The Learning for Well-being Framework suggests that mental, emotional, and physical aspects can be noticed in the way core capacities are experienced and expressed, and that together with the recognition of a spiritual dimension, they form a holistic, human-centred view on capacities.
                    </div>
                    <div className="panel-learnMoreWrp tabletHidden">
                        <StandardButton buttonText="Learn More" buttonIconURL="/assets/buttonLearnMoreIcon.svg"
                            buttonIconWidth={9} buttonClickCallback={this.didClickOnLearnMore}
                        ></StandardButton>
                    </div>
                    <div className="panel-learnMoreWrp desktopHiddenElement">
                        <StandardButton buttonText="Read More" buttonIconURL="/assets/readMoreIcon.svg"
                            buttonIconWidth={14} buttonClickCallback={this.presentModal} buttonTheme={StandardButtonTheme.whiteBackgroundBlueBorder}
                        ></StandardButton>
                    </div>
                </div>
            );
        } else {
            const contentPerspective = PerspectivesHelper.perspectiveContentForPerspective(this.props.perspective);
            content = (
                <div className={['panel-innerWrp', this.props.isActive ? 'active' : ''].join(' ')} key={contentPerspective.name}>
                    <div className="panel-title">{contentPerspective.name}</div>
                    <div className="panel-description mainDescription">
                        <span dangerouslySetInnerHTML={{ __html: contentPerspective.description }}></span>
                        <img className="mobile-whiteFader" src="/assets/tabletPanelWhiteFaderVerticalBottomToTop.png" alt="White gradient overlay to hide text. Purely visual." />
                    </div>
                    <div className="panel-learnMoreWrp tabletHidden">
                        <StandardButton buttonText="Learn More" buttonIconURL="/assets/buttonLearnMoreIcon.svg"
                            buttonIconWidth={9} buttonClickCallback={this.didClickOnLearnMore}
                        ></StandardButton>
                    </div>
                    <div className="panel-learnMoreWrp desktopHiddenElement">
                        <StandardButton buttonText="Read More" buttonIconURL="/assets/readMoreIcon.svg"
                            buttonIconWidth={14} buttonClickCallback={this.presentModal} buttonTheme={StandardButtonTheme.whiteBackgroundBlueBorder}
                        ></StandardButton>
                    </div>
                    <div className="separator tabletHidden"></div>
                    <div className="panel-learnMoreWrp tabletHidden">
                        <div className="panel-section-backHome">
                            <StandardButton buttonText="What are perspectives?" buttonClickCallback={() => { this.moveBackToMainSection() }}
                                buttonIconURL="/assets/buttonLearnMoreIcon.svg"
                            ></StandardButton>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <>
                {content}
            </>
        )
    }
}

export default PerspectivePanelItem;